// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__La4Do","checkboxCol":"Table_checkboxCol__2s0YA","emailCol":"Table_emailCol__ehQNt","actionCol":"Table_actionCol__1Plgr"};